import React from 'react';
import './Pricing.css';

// Import required components and constants
import { Heading, Plan } from '../../../components';
import { pricing } from '../../../constants';



const Pricing = () => {
  return (
    <section className='pricing'>

      {/* Section Heading */}
      <Heading title={'Our Pricing'} subTitle={'Our Plans'} />

      {/* Pricing container */}
      <div className='box-container'> 
        {/* Loop through each plan and render the Plan component */}
        {pricing.map((plan, index) => (
          <Plan key={index} plan={plan} />
        ))
        }
      </div>

    </section>
  )
}

export default Pricing;